import { render, staticRenderFns } from "./UpgradeNeeded.vue?vue&type=template&id=c1807d04"
import script from "./UpgradeNeeded.vue?vue&type=script&lang=js"
export * from "./UpgradeNeeded.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNeeded.vue?vue&type=style&index=0&id=c1807d04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports